var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcoElectricityWhite(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 30,
    viewBox: "0 0 36 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.92367 24.0667C8.47595 24.0667 8.92367 23.619 8.92367 23.0667C8.92367 22.5144 8.47595 22.0667 7.92367 22.0667V24.0667ZM2 20.2222H1H2ZM9.68596 7C10.2382 7 10.686 6.55228 10.686 6C10.686 5.44772 10.2382 5 9.68596 5V7ZM22.7329 5C22.1806 5 21.7329 5.44772 21.7329 6C21.7329 6.55228 22.1806 7 22.7329 7V5ZM20.9706 22.0667C20.4184 22.0667 19.9706 22.5144 19.9706 23.0667C19.9706 23.619 20.4184 24.0667 20.9706 24.0667V22.0667ZM7.92367 22.0667H4.96183V24.0667H7.92367V22.0667ZM4.96183 22.0667C3.83984 22.0667 3 21.2032 3 20.2222H1C1 22.3832 2.81227 24.0667 4.96183 24.0667V22.0667ZM3 20.2222V8.84444H1V20.2222H3ZM3 8.84444C3 7.86352 3.83984 7 4.96183 7V5C2.81227 5 1 6.68349 1 8.84444H3ZM4.96183 7H9.68596V5H4.96183V7ZM22.7329 7H25.6948V5H22.7329V7ZM25.6948 7C26.8168 7 27.6566 7.86352 27.6566 8.84444H29.6566C29.6566 6.68349 27.8443 5 25.6948 5V7ZM27.6566 8.84444V20.2222H29.6566V8.84444H27.6566ZM27.6566 20.2222C27.6566 21.2032 26.8168 22.0667 25.6948 22.0667V24.0667C27.8443 24.0667 29.6566 22.3832 29.6566 20.2222H27.6566ZM25.6948 22.0667H20.9706V24.0667H25.6948V22.0667Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M34.5803 15.9555V13.1111",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.8094 6L10.8857 14.5333H19.7712L13.8476 23.0667",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoElectricityWhite);
export default __webpack_public_path__ + "static/media/ico_electricity_white.9fda0150c43bbed1a51d00be2cc1072f.svg";
export { ForwardRef as ReactComponent };